export default __webpack_public_path__ + "static/media/Email_HeroImage.876e7e0e.png";